import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Defer until after framer-motion's AnimatePresence exit animation finishes
    // so the scroll happens on the incoming page, not the outgoing one
    const t = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, 20);
    return () => clearTimeout(t);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
